/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Empty_Trout_GripInputs */

const fr_game_empty_trout_grip = /** @type {(inputs: Game_Empty_Trout_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes séances par semaine`)
};

/**

* @param {Game_Empty_Trout_GripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const game_empty_trout_grip = /** @type {((inputs?: Game_Empty_Trout_GripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Empty_Trout_GripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_game_empty_trout_grip(inputs)
});